import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7be0140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs16" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "フォーム編集", -1))
const _hoisted_3 = { class: "flex-only" }
const _hoisted_4 = { class: "alert-flex" }
const _hoisted_5 = { class: "flex mt10" }
const _hoisted_6 = { class: "flex2" }
const _hoisted_7 = { class: "error" }
const _hoisted_8 = { class: "flex1 text-right" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("プレビュー")
const _hoisted_11 = { class: "mt10 flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入力周期:", -1))
const _hoisted_13 = {
  key: 0,
  class: "ml10"
}
const _hoisted_14 = { style: {"display":"inline-block"} }
const _hoisted_15 = {
  key: 1,
  class: "ml10 month-input"
}
const _hoisted_16 = { class: "error" }
const _hoisted_17 = { style: {"display":"inline-block"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "送信するプロジェクトを選択:", -1))
const _hoisted_19 = { class: "error" }
const _hoisted_20 = { class: "text-right" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "action" }
const _hoisted_23 = ["id"]
const _hoisted_24 = { class: "color-success" }
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "color-success" }
const _hoisted_27 = { class: "error" }
const _hoisted_28 = { class: "ml30 mt10" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "title" }),
  /*#__PURE__*/_createElementVNode("th", { class: "required" }, "必須"),
  /*#__PURE__*/_createElementVNode("th", { class: "threshold_min" }, "閾値Min"),
  /*#__PURE__*/_createElementVNode("th", { class: "threshold_max" }, "閾値Max"),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_30 = { class: "title" }
const _hoisted_31 = { class: "required" }
const _hoisted_32 = { class: "threshold_min" }
const _hoisted_33 = { class: "threshold_max" }
const _hoisted_34 = { class: "flex" }
const _hoisted_35 = { class: "error" }
const _hoisted_36 = { class: "error" }
const _hoisted_37 = { class: "mt10 text-left" }
const _hoisted_38 = { class: "ml20 mt_notice" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "通知設定", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml10 mt10" }, "通知方法", -1))
const _hoisted_41 = { class: "ml30 mt10" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Email")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("通知なし")
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml10" }, "通知対象", -1))
const _hoisted_45 = { class: "error" }
const _hoisted_46 = { class: "error" }
const _hoisted_47 = { class: "flex-only" }
const _hoisted_48 = { class: "alert-flex" }
const _hoisted_49 = { class: "flex mt10" }
const _hoisted_50 = { class: "flex1 text-right" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("作成画面へ戻る")
const _hoisted_53 = { class: "mt10" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("一覧へ戻る")

import { computed, onMounted, ref } from 'vue';
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import ProjectAlertFormInputForm from "@/components/project_alert_form/ProjectAlertFormInputForm.vue"
import { library } from "@fortawesome/fontawesome-svg-core";
import { useExceptionMessage } from '@/logic/ExceptionMessageLogic';
import { AlertFormsEditLogic } from "@/logic/alert_forms/AlertFormsEditLogic";
import { ProjectRepository } from '@/repositories/ProjectRepository';
import { faSortUp, faSortDown, faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

library.add( faSortUp, faSortDown, faPlus, faTimes);

const store = useStore();
const route = useRoute();
const managerFlg = computed(() => store.state.login.manager_flg);
const {
  up,
  down,
  get,
  alertForm,
  alertLoading,
  alertFormUpdate,
  update_compleate,
  addAlertFormItem,
  addAlertFormItemField,
  removeAlertFormItem,
  removeAlertFormItemField,
  alertFormNoticeSetting,
  projectIds
} = AlertFormsEditLogic();

const project_id = ref('');
const targets = ref('');
const preview = ref(false);
const month = ref('');
const cycle = ref('');
const cycleTyeps = [
  {
    value: 'monthly',
    label: '日付で指定',
  },
  {
    value: 'weekly',
    label: '曜日で指定',
  },
  {
    value: 'disabled',
    label: '送信停止',
  },
]
const week = ref([]);
const weeks = [
  {
    value: 1,
    label: '月',
  },
  {
    value: 2,
    label: '火',
  },
  {
    value: 3,
    label: '水',
  },
  {
    value: 4,
    label: '木',
  },
  {
    value: 5,
    label: '金',
  },
  {
    value: 6,
    label: '土',
  },
  {
    value: 0,
    label: '日',
  },
]

const errorBlank = (() => {
  form_error.value = '';
  email_error.value = '';
  project_list_error.value = '';
  title_error.value = [];
  small_title_error.value = [];
})

const form_error = ref();
const email_error = ref();
const project_list_error = ref();
const title_error = ref<number[]>([]);
const small_title_error = ref<number[]>([]);

const formErrorAdd = () => {
  form_error.value = "未入力";
}
const emailErrorAdd = () => {
  email_error.value = "メールアドレス未入力";
}
const projectListErrorAdd = () => {
  project_list_error.value = "送信するプロジェクト未選択";
}
const titleErrorAdd = (key: number) => {
  title_error.value.push(key);
}
const smallTitleErrorAdd = (key: number) => {
  small_title_error.value.push(key);
}

const saveAlertFormDisable = computed(() => {
  errorBlank();
  if(alertForm.value.title.length == 0){
    formErrorAdd();
  }
  if(targets.value.length == 0){
    if(alertFormNoticeSetting.value.notice_type == 'email'){
      emailErrorAdd();
    }
  }
  if(project_id.value.length == 0){
    projectListErrorAdd();
  }
  for(let f of alertForm.value.alert_form_items){
    if(f.title.length == 0){
      titleErrorAdd(f.key);
    }
    for(let fields of f.alert_form_item_fields){
      if(fields.title.length == 0){
        smallTitleErrorAdd(fields.key);
      }
    }
  }
  if (
    form_error.value.length > 0
    || title_error.value.length > 0
    || small_title_error.value.length > 0
    || threshold_min_error_key.value.length > 0
    || threshold_max_error_key.value.length > 0
    || cycle.value.length == 0
    || month.value.length == 0 && week.value.length == 0 && alertForm.value.input_terms_type !== 'disabled'
    || check_date_error.value
    || alertFormNoticeSetting.value.notice_type == 'email' && targets.value.length == 0
    || check_email_error.value.length > 0
    || project_list_error.value.length > 0){
    return true
  } else {
    return false
  }
})

const threshold_min_error_key = ref<number[]>([]);
const threshold_max_error_key = ref<number[]>([]);
const int_reg = new RegExp(/^[0-9]*$/);//整数
const decimal_reg = new RegExp(/^([1-9]\d*|0)\.(\d+)?$/);//小数
const minus_decimal_reg = new RegExp(/^([-1-9]\d*|0)\.(\d+)?$/);//マイナス小数
const minus_int_reg = new RegExp(/^[-0-9]*$/);//マイナス整数
const regs = [int_reg, decimal_reg, minus_decimal_reg, minus_int_reg];

const checkMin = (threshold, key) => {
  for(let i = 0; i < threshold_min_error_key.value.length; i++){
    if(threshold_min_error_key.value[i] == key){
      threshold_min_error_key.value.splice(i ,1);
    }
  }
  if(threshold === ''){
    return
  }
  const check_min_ok = regs.some(regsItem => regsItem.test(threshold) === true );
  if(!check_min_ok){
    threshold_min_error_key.value.push(key);
  }
}
const checkMax = (threshold, key) => {
  for(let i = 0; i < threshold_max_error_key.value.length; i++){
    if(threshold_max_error_key.value[i] == key){
      threshold_max_error_key.value.splice(i ,1);
    }
  }
  if(threshold === ''){
    return
  }
  const check_max_ok = regs.some(regsItem => regsItem.test(threshold) === true );
  if(!check_max_ok){
    threshold_max_error_key.value.push(key);
  }
}
const check_date_error = ref('');
const date_reg = new RegExp(/^[0-9,]+$/);//整数,カンマ
const checkDate = (month) => {
  check_date_error.value = '';
  if(month === ''){
    return
  }
  const result = month.match(date_reg);
  if(!result){
    check_date_error.value = '日付は整数を","で区切って入力';
  }
}
const check_email_error = ref('');
const email_reg = new RegExp(/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/);//メールアドレス
const checkemail = (email) => {
  check_email_error.value = '';
  if(email === ''){
    return
  }
  const result = email.match(email_reg);
  if(!result){
    check_email_error.value = 'メールアドレスを","で区切って入力';
  }
}

const clear = () => {
  if(alertForm.value.input_terms_type === 'monthly'){
    week.value = [];
  } else if( alertForm.value.input_terms_type === 'weekly') {
    month.value = '';
    check_date_error.value = '';
  } else {
    week.value = [];
    month.value = '';
    check_date_error.value = '';
  }
}

const clearTargets = () => {
  targets.value = [];
  check_email_error.value = '';
}

const updateSave = async () => {
  if(alertForm.value.input_terms_type == 'monthly'){
    alertForm.value.input_terms_timings = month.value.split(',');
  } else {
    alertForm.value.input_terms_timings = week.value;
    const weeks = Object.keys(week.value).map(function (key) {
      return week.value[key];
    });
    alertForm.value.input_terms_timings = weeks;
  }
  if(alertFormNoticeSetting.value.notice_type === 'email'){
    const target = targets.value.split(',').map( element => element );
    alertFormNoticeSetting.value.targets = target;
  }
  const projects = Object.keys(project_id.value).map(function (key) {
    return project_id.value[key];
  });
  projectIds.value = projects;
  alertFormUpdate(alertForm.value, alertFormNoticeSetting.value, projectIds.value);
}

const project_lists = ref([]);
onMounted(async (): Promise<void> => {
  try {
    await get(Number(route.params.alert_form_id));
    cycle.value = alertForm.value.input_terms_type;
    project_id.value =  projectIds.value.project_ids;
    const repository = new ProjectRepository();
    project_lists.value = await repository.getList();
    if(cycle.value === 'monthly'){
        month.value = alertForm.value.input_terms_timings.join(',');
    } else if(cycle.value === 'weekly'){
        week.value = alertForm.value.input_terms_timings;
    }
    if(alertFormNoticeSetting.value.notice_type == 'email'){
      targets.value = alertFormNoticeSetting.value.targets.join(',');
    }
  } catch (e: any) {
    useExceptionMessage(e, "エラーが発生しました。<br>再読み込みしてお試しください");
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_fa = _resolveComponent("fa")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(managerFlg))
    ? _withDirectives((_openBlock(), _createBlock(_component_el_card, {
        key: 0,
        class: "fs14 container container__card"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, " 保存しました ", 512), [
            [_vShow, _unref(update_compleate)]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(alertForm).title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(alertForm).title) = $event)),
                      placeholder: "入力フォームタイトル",
                      class: "form-title"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(form_error.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_button, {
                      type: "text",
                      disabled: _unref(saveAlertFormDisable),
                      onClick: updateSave
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      disabled: _unref(saveAlertFormDisable),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (preview.value = !preview.value))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _createVNode(_component_el_select, {
                      modelValue: _unref(alertForm).input_terms_type,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(alertForm).input_terms_type) = $event)),
                      class: "ml10 type-select",
                      placeholder: "入力周期",
                      onChange: clear
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cycleTyeps, (cycleTyep) => {
                          return _createVNode(_component_el_option, {
                            key: cycleTyep.value,
                            label: cycleTyep.label,
                            value: cycleTyep.value
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    (_unref(alertForm).input_terms_type == 'weekly')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_el_select, {
                              modelValue: week.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((week).value = $event)),
                              multiple: "",
                              disabled: false,
                              placeholder: "曜日を選択"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weeks, (week) => {
                                  return _createVNode(_component_el_option, {
                                    key: week.value,
                                    label: week.label,
                                    value: week.value,
                                    class: "week-input"
                                  }, null, 8, ["label", "value"])
                                }), 64))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(alertForm).input_terms_type == 'monthly')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_el_input, {
                            modelValue: month.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((month).value = $event)),
                            placeholder: "カンマ区切りで入力",
                            onInput: _cache[5] || (_cache[5] = ($event: any) => (checkDate(month.value)))
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("span", _hoisted_16, " 未入力 ", 512), [
                      [_vShow, _unref(alertForm).input_terms_type.length == 0
                || week.value.length == 0 && month.value.length == 0 && _unref(alertForm).input_terms_type !== 'disabled']
                    ]),
                    _withDirectives(_createElementVNode("span", { class: "error" }, _toDisplayString(check_date_error.value), 513), [
                      [_vShow, check_date_error.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_el_select, {
                    modelValue: project_id.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((project_id).value = $event)),
                    multiple: "",
                    "collapse-tags": "",
                    placeholder: "プロジェクト選択",
                    style: {"width":"240px"},
                    class: "ml10 mt10"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project_lists.value, (project) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: project.id,
                          label: project.name,
                          value: project.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(project_list_error.value), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(alertForm).alert_form_items, (alertFormItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: alertFormItem.key
                  }, [
                    _createVNode(_component_el_card, {
                      shadow: "never",
                      class: "mt10"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_el_button, {
                            onClick: ($event: any) => (_unref(removeAlertFormItem)(alertFormItem.key)),
                            type: "text"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_fa, {
                                class: "color-success",
                                icon: "times"
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", {
                              id: 'up_' + alertFormItem.key,
                              class: "up"
                            }, [
                              _createVNode(_component_el_button, {
                                type: "text",
                                onClick: ($event: any) => (_unref(up)(alertFormItem.key, alertFormItem.id))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_24, [
                                    _createVNode(_component_fa, { icon: "sort-up" })
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ], 8, _hoisted_23),
                            _createElementVNode("div", {
                              id: 'down_' + alertFormItem.key
                            }, [
                              _createVNode(_component_el_button, {
                                type: "text",
                                onClick: ($event: any) => (_unref(down)(alertFormItem.key, alertFormItem.id))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_26, [
                                    _createVNode(_component_fa, { icon: "sort-down" })
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ], 8, _hoisted_25)
                          ]),
                          _createVNode(_component_el_input, {
                            modelValue: alertFormItem.title,
                            "onUpdate:modelValue": ($event: any) => ((alertFormItem.title) = $event),
                            class: "ml10 form-category",
                            placeholder: "大カテゴリのフォーム"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _withDirectives(_createElementVNode("span", _hoisted_27, "未入力", 512), [
                            [_vShow, title_error.value.indexOf(alertFormItem.key) !== -1]
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_28, [
                          _createElementVNode("tbody", null, [
                            _hoisted_29,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alertFormItem.alert_form_item_fields, (alertFormItemField) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: alertFormItemField.key
                              }, [
                                _createElementVNode("td", _hoisted_30, [
                                  _createVNode(_component_el_input, {
                                    modelValue: alertFormItemField.title,
                                    "onUpdate:modelValue": ($event: any) => ((alertFormItemField.title) = $event),
                                    placeholder: "小カテゴリ"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", _hoisted_31, [
                                  _createVNode(_component_el_checkbox, {
                                    modelValue: alertFormItemField.required,
                                    "onUpdate:modelValue": ($event: any) => ((alertFormItemField.required) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", _hoisted_32, [
                                  _createVNode(_component_el_input, {
                                    modelValue: alertFormItemField.threshold_min,
                                    "onUpdate:modelValue": ($event: any) => ((alertFormItemField.threshold_min) = $event),
                                    onInput: ($event: any) => (checkMin(alertFormItemField.threshold_min, alertFormItemField.key))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                ]),
                                _createElementVNode("td", _hoisted_33, [
                                  _createVNode(_component_el_input, {
                                    modelValue: alertFormItemField.threshold_max,
                                    "onUpdate:modelValue": ($event: any) => ((alertFormItemField.threshold_max) = $event),
                                    onInput: ($event: any) => (checkMax(alertFormItemField.threshold_max, alertFormItemField.key))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_el_button, {
                                      onClick: ($event: any) => (_unref(removeAlertFormItemField)(alertFormItem, alertFormItemField.key)),
                                      type: "text"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_fa, {
                                          class: "color-success",
                                          icon: "times"
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createElementVNode("div", null, [
                                      _withDirectives(_createElementVNode("p", _hoisted_35, "小カテゴリ未入力", 512), [
                                        [_vShow, small_title_error.value.indexOf(alertFormItemField.key) !== -1]
                                      ]),
                                      _withDirectives(_createElementVNode("p", _hoisted_36, " 閾値:整数/小数/空欄 ", 512), [
                                        [_vShow, threshold_min_error_key.value.indexOf(alertFormItemField.key) !== -1 || threshold_max_error_key.value.indexOf(alertFormItemField.key) !== -1]
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_button, {
                            onClick: ($event: any) => (_unref(addAlertFormItemField)(alertFormItem)),
                            type: "text"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_fa, {
                                icon: "plus",
                                class: "color-success"
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_el_button, {
                    onClick: _unref(addAlertFormItem),
                    type: "text"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_fa, {
                        icon: "plus",
                        class: "color-success"
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_el_radio, {
                    modelValue: _unref(alertFormNoticeSetting).notice_type,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(alertFormNoticeSetting).notice_type) = $event)),
                    label: "email"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_42
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_radio, {
                    modelValue: _unref(alertFormNoticeSetting).notice_type,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(alertFormNoticeSetting).notice_type) = $event)),
                    label: "none",
                    onChange: clearTargets
                  }, {
                    default: _withCtx(() => [
                      _hoisted_43
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _hoisted_44,
                _createVNode(_component_el_input, {
                  modelValue: targets.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((targets).value = $event)),
                  placeholder: "カンマ区切りで入力",
                  disabled: _unref(alertFormNoticeSetting).notice_type === 'none',
                  onInput: _cache[10] || (_cache[10] = ($event: any) => (checkemail(targets.value)))
                }, null, 8, ["modelValue", "disabled"]),
                _createElementVNode("p", _hoisted_45, _toDisplayString(email_error.value), 1),
                _createElementVNode("p", _hoisted_46, _toDisplayString(check_email_error.value), 1)
              ])
            ])
          ], 512), [
            [_vShow, !_unref(update_compleate) && !preview.value]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_el_button, {
                      type: "text",
                      disabled: _unref(saveAlertFormDisable),
                      onClick: updateSave
                    }, {
                      default: _withCtx(() => [
                        _hoisted_51
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (preview.value = !preview.value))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_52
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createVNode(ProjectAlertFormInputForm, {
              alert_form: _unref(alertForm),
              preview: preview.value
            }, null, 8, ["alert_form", "preview"])
          ], 512), [
            [_vShow, !_unref(update_compleate) && preview.value]
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_router_link, {
              to: { name: 'AlertForms' },
              class: "button-link"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "text" }, {
                  default: _withCtx(() => [
                    _hoisted_54
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 512)), [
        [_directive_loading, _unref(alertLoading)]
      ])
    : _createCommentVNode("", true)
}
}

})